import { cn } from '@louez/utils'

interface LogoProps {
  className?: string
  width?: number
  height?: number
}

export function Logo({ className, width = 150, height = 28 }: LogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 150 28"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-foreground', className)}
      role="img"
      aria-label="Soluciones Serranas"
    >
      <text
        x="0"
        y="19"
        fill="currentColor"
        fontSize="17"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        Soluciones Serranas
      </text>
    </svg>
  )
}

// Symbol on its own, for small spaces. Same artwork as apps/web/public/favicon.svg,
// which every generated icon is rendered from — change one, change the other.
export function LogoIcon({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 154 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <g transform="translate(0 4)" fill="#0166FE">
        <path d="M82.4281 68.6013C101.112 53.2138 127.113 48.4352 151.22 50.0211C151.968 50.0705 152.716 50.1261 153.463 50.188L153.457 86.2722C135.865 83.7091 121.121 85.2736 106.285 95.6213C93.8642 104.262 85.6082 117.258 83.3603 131.705C82.6629 136.256 82.6374 140.821 82.7683 145.41L45.4077 145.382C44.1365 121.662 53.8277 92.1404 73.1794 76.2622L72.8408 75.7106C74.4446 73.8274 79.2722 69.4715 81.484 68.3397L82.4281 68.6013Z" />
        <path d="M72.8418 75.7107C74.4456 73.8275 79.2732 69.4716 81.485 68.3398L82.4291 68.6014C79.4297 71.1265 76.3519 74.0511 73.1804 76.2623L72.8418 75.7107Z" />
        <path d="M70.7209 0L108.245 0.0361355C108.815 26.6839 100.993 48.8116 81.4842 68.34C79.2723 69.4718 74.4448 73.8277 72.8409 75.7109C72.2354 76.2958 70.7394 77.3847 70.0236 77.9031C50.5574 92.0313 24.2285 98.1087 0.0185553 95.0082L0 59.1931C4.74275 59.7713 8.98885 60.3529 13.7998 60.321C29.1578 60.1841 43.8225 54.2403 54.5371 43.8099C67.8719 30.7744 70.9863 17.32 70.7209 0Z" />
        <path d="M117.622 97.7187C129.3 96.3206 139.944 104.21 141.324 115.295C142.703 126.375 134.289 136.399 122.588 137.612C111.024 138.81 100.602 130.949 99.2388 119.998C97.8758 109.051 106.081 99.1025 117.622 97.7187Z" />
        <path d="M30.7434 9.26173C41.7424 7.45278 52.1896 14.485 54.0122 24.9245C55.8347 35.3645 48.3343 45.2119 37.3072 46.8577C26.4014 48.486 16.1514 41.4713 14.3489 31.1465C12.5464 20.8216 19.8657 11.0512 30.7434 9.26173Z" />
      </g>
    </svg>
  )
}
